const capitalizeFirstLetter = str => {
  const firstLetterCap = str.charAt(0).toUpperCase();
  const remainingLetters = str.slice(1);

  return firstLetterCap + remainingLetters;
};

function getTextWidthInOneLine(
  inputText,
  font = '12px Roboto, Helvetica, Arial, sans-serif',
  letterSpacing = '0.01071em',
) {
  if (!inputText) return 0;

  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  context.font = font;
  context.letterSpacing = letterSpacing;

  const { width } = context.measureText(inputText);

  return Math.ceil(width);
}

const getHTMLWrapper = body =>
  '<!DOCTYPE html>' +
  '<html>' +
  '<head>' +
  '<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0"/>' +
  '<style>' +
  "@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@" +
  '0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;' +
  "1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap'); " +
  'body {font-family: "Poppins";}' +
  '</style>' +
  `<body>${body}</body>` +
  '</html>';

const getHTMLBody = v => {
  const parser = new DOMParser();
  const dom_document = parser.parseFromString(v, 'text/html');
  const body_element = dom_document.getElementsByTagName('body')[0];

  return body_element.innerHTML;
};

export { capitalizeFirstLetter, getTextWidthInOneLine, getHTMLWrapper, getHTMLBody };
